import axios from 'axios';
import { GetAppTranslationsV1ResponsePayload } from '@ilteducation/babelfish-types';
import { GetDownloadUrlV1ResponsePayload, ImageV1 } from '@ilteducation/content-registry-types';
import { babelfishUrl, contentRegistryUrl } from './content-registry-url';

/**
 * Read access to images.
 *
 * Everything that writes lives in `admin-api.ts` and is only reachable through
 * the `@ilteducation/images/admin` entry point.
 */

export const getById = (imageId: string): Promise<ImageV1> =>
  axios.get<ImageV1>(`${contentRegistryUrl()}/${imageId}`).then((response) => response.data);

/** Presigned URL the image bytes are served from. */
export const getImageUrl = async (imageId: string): Promise<string> => {
  const response = await axios.get<GetDownloadUrlV1ResponsePayload>(`${contentRegistryUrl()}/${imageId}/contentUrls`);
  return response.data.url;
};

export const getAltText = async (imageId: string, lang: string): Promise<string> => {
  const crTranslation = await getById(imageId);
  if (crTranslation && crTranslation.language === lang) {
    return crTranslation.altText || '';
  }
  return '';
};

export const getAltTextsTranslations = async (
  imageIds: string[],
): Promise<{ [imageId: string]: { [lang: string]: string } }> => {
  const babelfishTranslations = await axios
    .get<GetAppTranslationsV1ResponsePayload>(`${babelfishUrl()}/app/v2/translations?sourceIds=${imageIds.join(',')}`)
    .then((res) => res.data);

  const result: { [imageId: string]: { [lang: string]: string } } = {};
  Object.keys(babelfishTranslations).map((imageId) => {
    const translations = babelfishTranslations[imageId]?.altText || {};
    result[imageId] = Object.fromEntries(
      Object.entries(translations).map(([lang, translation]) => [lang, translation.translation]),
    );
  });
  return result;
};
